/* Retail motion: progressive enhancement; content stays visible without JavaScript. */
(() => {
  const media = matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const active = new Map();
  let observer;
  const selector = [
    '.rt-home-campaign', '.rt-home-riding__card', '.rt-home-story__copy', '.rt-home-makes__links > a',
    '.rt-contact-channels__item', '.rt-contact-map__intro', '.rc-hero-copy > *', '.rc-heading', '.rc-stats > div', '.rc-service',
    '.rc-products > article', '.rc-editorial-media', '.rc-gallery figure',
    '.rc-process > li', '.rc-points > article', '.rc-contact-form',
    '.rt-hero-copy > *', '.rt-section-head', '.rt-finder', '.rt-category',
    '.rt-product-card', '.rt-newsletter > .rt-wrap',
    '#MainContent .title-wrapper-with-link', '#MainContent .collection-hero__text-wrapper',
    '#MainContent .product-grid > li', '#MainContent .rich-text__blocks',
    '#MainContent .image-with-text__content', '#MainContent .multicolumn-list > li',
    '#MainContent .blog-articles > article', '#MainContent .main-page-title',
    '#MainContent .product__title', '#MainContent .product__description > h2'
  ].join(',');
  const enabled = () => document.body.classList.contains('rt-motion-enabled') && !media.matches && !window.Shopify?.designMode;
  function finish(element) {
    const animation = active.get(element);
    if (animation) { animation.cancel(); active.delete(element); }
  }
  function reveal(element, delay = 0) {
    if (!enabled() || typeof element.animate !== 'function' || element.contains(document.activeElement)) return;
    const compact = matchMedia('(max-width: 749px)').matches;
    const animation = element.animate([
      { opacity: 0, transform: 'translateY(' + (compact ? 10 : 18) + 'px)' },
      { opacity: 1, transform: 'translateY(0)' }
    ], { duration: compact ? 400 : 560, delay, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
    active.set(element, animation);
    animation.finished.then(() => { if (active.get(element) === animation) active.delete(element); }).catch(() => {});
  }
  function init(root = document) {
    if (!enabled() || !('IntersectionObserver' in window)) return;
    if (!observer) observer = new IntersectionObserver(entries => {
      const visible = entries.filter(entry => entry.isIntersecting);
      visible.forEach((entry, index) => {
        observer.unobserve(entry.target);
        reveal(entry.target, Math.min(index, 3) * 65);
      });
    }, { threshold: 0.06 });
    root.querySelectorAll(selector).forEach(element => {
      if (seen.has(element) || element.closest('[hidden], [aria-hidden="true"], .scroll-trigger')) return;
      // Animate one level only, keeping forms, sliders and nested content stable.
      if (element.parentElement?.closest(selector)) return;
      seen.add(element);
      observer.observe(element);
    });
  }
  document.addEventListener('focusin', event => {
    for (const element of active.keys()) if (element.contains(event.target)) finish(element);
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const element of event.target.querySelectorAll(selector)) { observer?.unobserve(element); finish(element); }
  });
  document.addEventListener('shopify:section:select', event => {
    for (const element of active.keys()) if (event.target.contains(element)) finish(element);
  });
  media.addEventListener('change', () => {
    if (media.matches) { observer?.disconnect(); for (const element of active.keys()) finish(element); }
    // A preference change never replays already displayed content.
    else init();
  });
  addEventListener('pagehide', () => { observer?.disconnect(); for (const element of active.keys()) finish(element); });
  addEventListener('pageshow', event => { if (event.persisted) init(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
